import React from 'react';
import { observer } from 'mobx-react';
import Snackbar from '@material-ui/core/Snackbar';
import IconButton from '@material-ui/core/IconButton';
import { amber, green } from '@material-ui/core/colors';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Tooltip from '@material-ui/core/Tooltip';
import CloseIcon from '@material-ui/icons/Close';
import ReplayIcon from '@material-ui/icons/Replay';

import { messageList } from '../store/MessageList';
import failedRequests from '../store/failedRequests';


const styles = theme => ({
  snackbar: {
    display: 'flex',
    flexWrap: 'nowrap',
  },
  message: {
    maxWidth: '80vw',
    maxHeight: '40vh',
    overflow: 'auto',
  },
  success: {
    backgroundColor: green[600],
  },
  warning: {
    backgroundColor: amber[700],
  },
  error: {
    backgroundColor: theme.palette.error.dark,
  },
  rawData: {
    whiteSpace: 'pre-wrap',
    overflowWrap: 'break-word',
  },
});


@withStyles(styles)
@observer
class MessagesView extends React.Component {
  close = () => {
    messageList.closeCurrent();
  };

  get message() {
    return messageList.currentMessage;
  }

  get content() {
    const { content, rawData } = this.message;
    if (rawData !== null) {
      return (
        <Grid container direction="column" wrap="nowrap">
          <Grid item>
            {content}
          </Grid>
          <Grid item>
            <pre className={this.props.classes.rawData}>{`${this.message.rawData}`}</pre>
          </Grid>
        </Grid>
      );
    }
    return content;
  }

  render() {
    const { classes } = this.props;
    if (failedRequests.remainingTime !== null) {
      const seconds = Math.round(failedRequests.remainingTime / 1000);
      return (
        <Snackbar
          open
          ContentProps={{
            className: `${classes.snackbar} ${classes.warning}`,
          }}
          message={`Network error, could not reach the server. Retrying in ${seconds} seconds.`}
          action={
            <Tooltip title="Retry now" onClick={failedRequests.forceRetry}>
              <IconButton color="inherit"><ReplayIcon /></IconButton>
            </Tooltip>
          }
        />
      );
    }
    const message = this.message;
    return (
      <Snackbar
        open={!messageList.empty}
        onClose={this.close}
        ContentProps={{
          className: `${classes[message.variant]} ${classes.snackbar}`,
          classes: {
            message: classes.message,
          },
        }}
        message={this.content}
        action={
          <IconButton color="inherit" onClick={this.close}><CloseIcon /></IconButton>
        }
      />
    );
  }
}


export default MessagesView;
